const isLoaded = () => !!(window.Klarna && window.Klarna.Payments);

const load = (() => {
    let result;

    return async () => {
        result =
            result ||
            new Promise((resolve, reject) => {
                if (isLoaded()) {
                    resolve(true);
                    return;
                }

                const script = document.createElement('script');
                script.src = '//x.klarnacdn.net/kp/lib/v1/api.js';
                script.onerror = () => reject(false);

                document.head.appendChild(script);
            });

        return await result;
    };
})();

export default {
    isLoaded,
    load,
};
